import ListGroup from 'react-bootstrap/ListGroup';
import Table from 'react-bootstrap/Table';
import React from 'react';

import InputField from 'components/FieldTypes/InputField';

/**
 * @fileoverview
 * Wrappers for various types of common form components
 * Inputs' 'title' properties are displayed on the previous row by default, unless prependTitle is also passed
 * Inputs are 'lg' size by default
 * (removed) Inputs have red color if no onChange is specified to highlight unimplemented inputs
 *
 * Settings-specific components <Action>, <Page> and <Section>
 * */

/** A wrapper for a bunch of Inputs that groups them under a common title */
export function Section({ title = undefined, children = [] }) {
  return (
    <>
      {title ? <h4 style={{ fontSize: 16 }}>{title}</h4> : undefined}
      <Table size="sm">
        <tbody>
          {React.Children.map(children, (child, i) => (
            <tr key={(child.props && child.props.name) || i}>
              <td>{child}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
}

/** A fullwidth button to perform some action */
export function Action({ title, onClick, ...rest }) {
  return (
    <ListGroup.Item
      action
      as="li"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
      {...rest}
    >
      {title}
    </ListGroup.Item>
  );
}

/**
 * A fullwidth button that redirects the user to a subpage
 * @param {Object} props
 * @param {string} props.title The title to display on the button
 * @param {string} props.value The page to open when clicked
 * @param {Object} props.props The props to pass to the opened page
 */
// export const Page = ({ title, value, props = {} }) => {
//   const dispatch = useDispatch();
//   const action = useCallback(
//     () => value && dispatch(openModalPage({ component: value, props })),
//     [value, dispatch, props],
//   );
//
//   return (
//     <Action
//       title={
//         <>
//           {title}
//           <i
//             className="arrow arrow_carrot-right"
//             style={{ fontSize: 24, float: 'right' }}
//           />
//         </>
//       }
//       onClick={action}
//     />
//   );
// };

/** A check box */
export function Checkbox({ title, name, value, onChange, children, ...rest }) {
  return (
    <InputField
      type="checkbox"
      size="lg"
      value={value}
      onChange={(e) => onChange(name, e.target.value)}
      title={title}
      numeric
      {...rest}
    >
      <div style={{ color: name ? '' : 'red' }}>{children}</div>
    </InputField>
  );
}

/**
 * A Text field
 * @param props
 * @param {string} props.title A title to display in front of the text field (or in the text field if prependTitle is also passed
 * @param {string} [props.prependTitle] A title to display in front of the field instead of 'title' - if this is defined then title is displayed as the PrependText of the input instead
 */
export function TextField({
  title = undefined,
  name,
  value,
  onChange,
  prependTitle,
  ...rest
}) {
  return (
    <>
      {title && !prependTitle ? <span>{title}</span> : undefined}

      <InputField
        size="lg"
        title={prependTitle ? title : undefined}
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        {...rest}
      />
    </>
  );
}

/**
 * A multiline text field
 * @param props
 * @param {string} props.title A title to display in front of the text field (or in the text field if prependTitle is also passed
 * @param {string} [props.prependTitle] A title to display in front of the field instead of 'title' - if this is defined then title is displayed as the PrependText of the input instead
 */
export function TextArea({
  title = undefined,
  name,
  value,
  onChange,
  ...rest
}) {
  return (
    <>
      {title ? <span>{title}</span> : undefined}
      <InputField
        size="lg"
        as="textarea"
        value={value}
        style={{ fontSize: 16 }}
        onChange={(e) => onChange(name, e.target.value)}
        rows={4}
        {...rest}
      />
    </>
  );
}

/**
 * A Select field
 * @param props
 * @param {string} props.title A title to display in front of the text field (or in the text field if prependTitle is also passed
 * @param {string} [props.prependTitle] A title to display in front of the field instead of 'title' - if this is defined then title is displayed as the PrependText of the input instead
 */
export function SelectField({
  title = undefined,
  name,
  options,
  value,
  prependTitle,
  onChange,
  ...rest
}) {
  return (
    <>
      {title && !prependTitle ? <span>{title}</span> : undefined}
      <InputField
        size="lg"
        title={prependTitle ? title : undefined}
        onChange={(e) => onChange(name, e.target.value)}
        value={value}
        options={options}
        type="select"
        {...rest}
      />
    </>
  );
}
